@import 'styles/variables';
@import 'styles/mixins';

.formatBarLink {
  a {
    color: var(--neutral-50);
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .linkTitle {
    max-width: 203px;
    @include line-clamp;
  }
}
